import { Component, Input, Output, EventEmitter, OnChanges, OnInit } from '@angular/core';
import { TreeNode } from './ng-tree-table/model';

import { TreeTable } from './ng-tree-table/treetable';
import { Funcionalidade } from './funcionalidade.model';
import { No } from './no.model';

@Component({
  selector: 'arvore-acesso',
  templateUrl: './arvore-acesso.component.html',
  styleUrls: [ './arvore-acesso.component.scss' ]
})

export class ArvoreAcessoComponent implements OnInit, OnChanges {

  @Input() acessosPermitidos = [];
  @Input() modulos = [];

  @Output() salvar = new EventEmitter();
  @Output() cancelar = new EventEmitter();

  funcionalidades : Array<No> = [];
  selecionados : Array<No> = [];
  acessos : Array<No> = [];

  public todosMarcados = false;
  public arvoreCarregada: boolean;

  ngOnChanges() {
    this.montarArvore();
  }

  ngOnInit() {
    this.arvoreCarregada = false;
  }

  onSalvar() {
     let acessosSelecionados = [];
     for(let funcionalidade of this.selecionados) {
      if(funcionalidade.data.acesso) {
        acessosSelecionados.push(funcionalidade.data.acesso);
      }
     }

    this.salvar.emit(acessosSelecionados);
  }

  onCancelar() {
    this.cancelar.emit();
  }

  getStyle(valor?: any) {
    let estilo =  {
      'text-align':'center'
      ,'font-weight': 'bold'
      ,'color': valor == 'Acesso Permitido' ? 'green' : (valor == 'Sem Acesso Parcial' ? 'red' : 'gray')
    };

    return estilo;
  }

  montarArvore() {
    // verifica se a árvore não foi criada
    if(this.funcionalidades.length == 0) {
      for(let modulo of this.modulos) {
        let noModulo:No = new No(modulo.nome, new Funcionalidade(modulo.nome));

        if(modulo.cenarios) {
          for(let cenario of modulo.cenarios) {
            let noCenario:No = new No(cenario.nome, new Funcionalidade(cenario.nome));
            noCenario.parent = noModulo;

            if(cenario.acessos) {
              for(let acesso of cenario.acessos) {
                let noAcesso:No = new No(acesso.nome,new Funcionalidade(acesso.nome, acesso.id));
                noAcesso.parent = noCenario;
                noCenario.children.push(noAcesso);

                this.acessos.push(noAcesso);
              }
            }

            noModulo.children.push(noCenario);
          }
        }

        this.funcionalidades.push(noModulo);
      }
    }

    // marcando acessos permitidos
    for(let acesso of this.acessos) {
      let index: number = this.acessosPermitidos.indexOf(acesso.data.acesso);
      if (index !== -1) {
        this.marcarAcesso(acesso);
      }
    }

    this.atualizaTodosMarcados();

    if(this.funcionalidades.length !== 0) {
      this.arvoreCarregada = true;
    }
  }

  // tratamento de eventos do componente da tree-table

  onNodeSelect(event) {
    this.atualizarNo(event.node, true);
  }

  onNodeUnselect(event) {
    this.atualizarNo(event.node, false);
  }

  // taratamento do status do nó

  atualizarStatus(no) {
    if(no) {
      if(no.selected) {
        no.data.status = "Acesso Permitido";
      } else if(no.partialSelected) {
        no.data.status = "Acesso Parcial";
      } else {
        no.data.status = "Sem Acesso";
      }
    }
  }

  // mudando a selecão da árvore a partir do código

  alterarSelecaoNo(no, selected, partialSelected=false) {
    no.selected = selected;
    no.partialSelected = partialSelected;
    this.atualizarStatus(no);

    let index: number = this.selecionados.indexOf(no);

    if(selected) {
      if (index == -1) {
        this.selecionados.push(no);
      }
    } else {
      if (index !== -1) {
        this.selecionados.splice(index, 1);
      }
    }
  }

  marcarAcesso(no) {
    this.alterarSelecaoNo(no,true);
    this.atualizarAscendentes(no.parent);
  }

  atualizarNo(no, selected) {
    this.alterarSelecaoNo(no, selected);
    this.atualizarDescendentes(no, selected);
    this.atualizarAscendentes(no.parent);
    this.atualizaTodosMarcados();
  }

  // tratamento de atualização da árvore

  atualizarDescendentes(no:TreeNode, selected) {
     if(no) {
         if(no.children) {
             for(let noFilho of no.children) {
                this.alterarSelecaoNo(noFilho, selected);
                this.atualizarDescendentes(noFilho, selected);
             }
         }
     }
  }

  atualizarAscendentes(no:TreeNode) {
     if(no) {

        let todosFilhosSelecionados = true;
        let temFilhosSelecionadosOuParcialmenteSelecionados = false;

        for(let noFilho of no.children) {
          if(!noFilho.selected) {
            todosFilhosSelecionados = false;
          }

          if(noFilho.selected || noFilho.partialSelected) {
            temFilhosSelecionadosOuParcialmenteSelecionados = true;
          }
        }

        let selected;
        let partialSelected;

        if(todosFilhosSelecionados) {
          selected = true;
          partialSelected = false;
        } else if(temFilhosSelecionadosOuParcialmenteSelecionados) {
          selected = false;
          partialSelected = true;
        } else {
          selected = false;
          partialSelected = false;
        }

        this.alterarSelecaoNo(no, selected, partialSelected);
        this.atualizarAscendentes(no.parent);
     }
  }

  // tratamento marcar/desmarcar todos os nós

  marcarTodos() {
    for(let n of this.funcionalidades) {
      this.atualizarNo(n, true);
    }

    this.todosMarcados = true;
  }

  desmarcarTodos() {
    for(let n of this.funcionalidades) {
      this.atualizarNo(n, false);
    }

    this.todosMarcados = false;
  }

  atualizaTodosMarcados() {
    this.todosMarcados = true;

    for(let n of this.funcionalidades) {
      if(!n.selected) {
        this.todosMarcados = false;
        break;
      }
    }
  }

  // tratamento de expação dos nós

  expandirTodos() {
    for(let n of this.funcionalidades) {
      this.alterarExpansaoDoNo(n, true);
    }
  }

  recolherTodos() {
    for(let n of this.funcionalidades) {
      this.alterarExpansaoDoNo(n, false);
    }
  }

  alterarExpansaoDoNo(no: No, expanded:boolean) {
    no.expanded = expanded;

    if(no.children) {
      for(let c of no.children) {
        this.alterarExpansaoDoNo(c, expanded);
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/arvore-acesso/arvore-acesso.component.ts